import Vue from 'vue';
import moment from 'moment';

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(new Date(value)).format('YYYY-MM-DD')
    }
});

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(new Date(value)).format('L LT')
    }
});


// WEBPACK FOOTER //
// ./src/filters.js